/**
 * The URL of another Mindstone space, built from the current space's app URL.
 *
 * A space is served on its own host, whose first label is the space's
 * uniqueName (`https://<uniqueName>.<rest of host>`). This swaps that first
 * label only, so the scheme, port and the rest of the host never change. It
 * used to be `appUrl.replace(from, to)`, which replaces the first substring
 * match: a space called `s` turned `https://` into `httpx://`.
 *
 * When the first label is not `fromUniqueName` the origin is returned as it
 * is. The path is appended only when one is given.
 */
export function spaceUrl(appUrl: string, fromUniqueName: string, toUniqueName: string, path = ""): string {
  const url = new URL(appUrl);
  const [firstLabel, ...rest] = url.hostname.split(".");
  if (firstLabel === fromUniqueName && rest.length > 0) {
    url.hostname = [toUniqueName, ...rest].join(".");
  }
  return url.origin + path;
}
